/**
 * 图片加载
 */
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
type Props = React.ImgHTMLAttributes<HTMLImageElement>;
export default function Image(props: Props) {
  const [src, setSrc] = useState('');
  const [load, setLoad] = useState(false);
  /**
   * 图片是否已经加载完毕
   */
  const onLoad = () => {
    setLoad(true);
  };
  useEffect(() => {
    if (props.src) {
      const reg = /w_\d+/;
      if (!reg.test(props.src)) {
        // 未匹配到则 使用原先地址
        setSrc(props.src);
        return;
      }
      const newPath = props.src.replace(reg, 'w_10');
      setSrc(newPath);
    }
  }, [props.src]);
  return (
    <>
      <img
        {...props}
        onLoad={onLoad}
        className={classNames(props.className, styles.show, {
          [styles.load]: load,
        })}
      />
    </>
  );
}
